
export default () => (text,number) => {
    if (text) return (text.length > number) ?  (text.slice(0,(number-1)) + '...') :  text;
}

